'use client'
import { PortableText } from '@portabletext/react'
import { getPortableTextComponents } from 'app/components/PortableTextComponents'
import { useState } from 'react'

interface Props {
  blocks: any
}

export default function AboutBody({ blocks }: Props) {
  const [headingInView, setHeadingInView] = useState<string | undefined>()

  const handleInView = (inView: boolean, entry: IntersectionObserverEntry) => {
    if (inView) {
      setHeadingInView(entry.target.children[0].id)
    }
  }
  return (
    <main className="mx-auto max-w-5xl px-4 py-16 md:px-8">
      <PortableText
        value={blocks}
        components={getPortableTextComponents(handleInView)}
      />
    </main>
  )
}
